module.exports = __webpack_public_path__ + "media/images/heartbeat-c147f2df.svg";